import React from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { SET_AUTH } from '../actions/authTypes'

const authRoutes = ['/login','/forgot-password','/signup']

const PublicRoute = ({children}) => {
    const isLoggedIn = useSelector((state)=>state.authState.isLoggedIn)
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        const handleStorageEvent = (e) => {
            const currentPath = location.pathname
            if (e.key === 'login-event') {
                const isAuthPage = authRoutes.includes(currentPath)
                if (isAuthPage) {
                    const user = JSON.parse(localStorage.getItem('user'));
                    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
                    if (isLoggedIn && user) {
                        dispatch({type:SET_AUTH,payload:user})
                        navigate('/notes')
                    }
                }
            }
        }
        window.addEventListener('storage', handleStorageEvent)
        return () => window.removeEventListener('storage', handleStorageEvent)
    }, [location, navigate,dispatch])

    return (
        !isLoggedIn ? children : <Navigate to = "/notes" replace = {true}/>
    )
}

export default PublicRoute